function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#63CE92"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.193 27.298a1 1 0 010 1.413l-1.243 1.25a7.004 7.004 0 01-9.902-9.908l3.015-3.015a7 7 0 019.601-.285 1.002 1.002 0 11-1.33 1.5 5 5 0 00-6.856.203l-3.015 3.012a5.001 5.001 0 107.072 7.072l1.243-1.242a1 1 0 011.415 0zm8.76-17.25a7.01 7.01 0 00-9.903 0l-1.242 1.243a1 1 0 101.415 1.414l1.242-1.242a5.001 5.001 0 017.073 7.072l-3.015 3.018a5 5 0 01-6.857.2 1.004 1.004 0 00-1.33 1.5 7 7 0 009.602-.283l3.015-3.015a7.01 7.01 0 000-9.905v-.002z",
  fill: "#fff"
});

function SvgCopyLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgCopyLink;